<div class="page-loader-shade">
  <mat-spinner [diameter]="30"></mat-spinner>
</div>
